export default {
    businessMatchHome: {
      howCanIHelp: '今天我能幫您建立什麼連結？',
      findIdealMatches: '尋找理想的商務夥伴',
      matchWithMembers: '與能幫助您事業成長的 {title} 成員配對',
      titleAll: '所有',
      stepOf: '第 {current} 步，共 {total} 步',
      enterInfo: '輸入您的資訊',
      inputKeywords: '輸入關鍵字',
      uploadPdf: '上傳 PDF',
      workEmail: '工作信箱',
      websiteUrl: '公司網址',
      linkedinUrl: 'LinkedIn 網址',
      placeholderKeywords: '例如：我是裝潢公司，想找房仲合作...',
      keywordsDesc: '輸入關鍵字以尋找特定類型的會員或商機。',
      clickForExample: '點擊快速範例：',
      findMatches: '找到我的配對',
      switchToDemandKeywords: '切換到需求關鍵字搜尋',
      switchToSupplyKeywords: '切換到供應關鍵字搜尋',
      keywordsExample1: '找高雄的刑事訴訟律師',
      keywordsExample2: '找運動服加工廠，能處理吸濕排汗布料',
      keywordsExample3: '需要會計服務的公司',
      keywordsExampleForCompany1: '尋找標籤顯示器或電子紙',
      keywordsExampleForCompany2: '找客製化工業用電腦',
      keywordsExampleForCompany3: '虛擬實境應用廠商',
      supplyKeywordsExample1: '亞洲 TikTok 直播推廣',
      supplyKeywordsExample2: '協助品牌連結行銷高層',
      supplyKeywordsExample3: '日本跨境物流服務',
      supplyKeywordsExample1ForCes: '智慧型手機配件製造商尋找經銷商',
      supplyKeywordsExample2ForCes: '提供消費性電子 ODM 服務的設計公司',
      supplyKeywordsExample3ForCes: '智慧家庭整合商尋找硬體合作夥伴',
      examples: {
        other: {
          commonSearches: {
            title: '常見搜尋',
            examples: [
              '我提供房屋抵押貸款，想找房地產經紀人',
              '我提供清潔服務，想透過物業管理公司引薦客戶',
              '找需要會計服務的公司',
              '找醫療保險服務',
              '找 IT 顧問',
              '找西雅圖的室內裝修公司'
            ]
          },
          newCustomerDevelopment: {
            title: '開發新客戶',
            examples: [
              '找需要汽車貸款的客戶',
              '找需要攝影服務的客戶',
              '找需要農產原物料的客戶',
              '找需要金融服務的客戶',
              '尋找需要第三方支付或跨境金流解決方案的客戶'
            ]
          },
          professionalServices: {
            title: '專業服務',
            examples: [
              '找智慧財產權專業律師',
              '找社群行銷顧問',
              '找熟悉美國不動產交換稅法的專家',
              '需要法規遵循顧問，要熟悉台灣金融法規',
              '尋找一對一運動教練服務'
            ]
          },
          businessNetworking: {
            title: '業務人脈',
            examples: [
              '我是裝潢公司，想透過房仲引薦有裝潢需求的屋主',
              '我是保險業務，想透過車商引薦有車險需求的車主',
              '我提供包車服務，想透過旅行社找需要包車服務的客人',
              '我提供公證服務，想透過房貸專員引薦客戶'
            ]
          },
          regionalBusinessMatching: {
            title: '地區商機媒合',
            examples: [
              '找台北市的網站設計公司',
              '找新北市的室內設計師',
              '找高雄市的港口物流公司'
            ]
          }
        },
        track47: {
          productAndTechnology: {
            title: '產品及技術',
            examples: [
              '尋找NAS網路儲存設備，要支援RAID 10配置',
              '尋找 USB4 傳輸線，要支援 100W 快充',
              '尋找資料中心用的網路交換機',
              '尋找自動駕駛車輛用的 LiDAR 感測器',
              '尋找擁有 BCI(腦機介面) 及 EEG(腦電圖) 技術的供應商',
              '尋找協助行動不便與視障人士的智慧產品',
              '尋找國際設計獎得獎的消費電子產品',
              '尋找娛樂與媒體領域的新技術'
            ]
          },
          solutions: {
            title: '解決方案',
            examples: [
              '尋找智慧零售解決方案',
              '尋找邊緣運算解決方案，要支援 5G 模組',
              '尋找 ESG 碳排放管理解決方案',
              '尋找虛擬實境應用解決方案'
            ]
          },
          businessPartners: {
            title: '合作夥伴',
            examples: [
              '尋找 AI 新創加速器',
              '尋找電動車技術合作夥伴',
              '尋找全像投影相關供應鏈合作夥伴',
              '尋找金融科技公司合作開發解決方案',
              '尋找農業科技公司'
            ]
          },
          marketExpansion: {
            title: '市場拓展',
            examples: [
              '尋找電子消費產品經銷商',
              '尋找跨境電商平台',
              '尋找互動多媒體展演的通路推廣合作'
            ]
          },
          mediaMarketing: {
            title: '媒體行銷',
            examples: [
              '尋找報導產業新聞的媒體',
              '尋找科技Podcast合作',
              '尋找國際廣告代理商做整合行銷'
            ]
          }
        },
        track8: {
          franchiseExamples: {
            title: '加盟範例',
            examples: [
              '我們需要數位行銷與社群媒體管理服務',
              '我們需要員工培訓與認證系統',
              '我們需要選址評估與建置成本控制服務',
              '我們提供特許經營融資服務',
              '我們是行銷服務供應商，需要數據分析與行銷自動化技術'
            ]
          }
        }
      },
      uploadYourFile: '上傳您的檔案',
      dragPdfHere: '將 PDF 檔案拖放到這裡',
      releaseToUpload: '放開以上傳',
      orClickButton: '或點擊下方按鈕選擇檔案',
      selectFile: '選擇檔案',
      changeFile: '更換檔案',
      clickToChange: '點擊下方按鈕更換檔案',
      uploadPdfDescription: '上傳您的 PDF（例如 GAINs 表格）以尋找可以合作的會員。',
      workEmailDescription: '輸入您的公司 Email，尋找可能需要貴公司服務或產品的會員。',
      websiteUrlDescription: '輸入您的公司網址，尋找可能需要貴公司服務或產品的會員。',
      linkedInUrlDescription: '輸入您的 LinkedIn 網址，尋找可以建立人脈的會員。',
      onboardingDialog: {
        title: '快速設定個人資料',
        description: '此資訊有助於我們為您找到最合適的商業夥伴，並改善您的社交體驗。',
        descriptionPage2: '完善您的個人資料',
        yourNameLabel: '您的名字',
        titleLabel: '職稱',
        jobTitleLabel: '職位',
        emailLabel: '電子郵件',
        phoneLabel: '電話',
        industryLabel: '行業',
        bioLabel: '個人描述',
        companyNameLabel: '公司名稱',
        companyWebsiteLabel: '公司網站',
        websiteUsageHint: '我們將使用您的網站來更了解您的業務。',
        nextStep: '下一步',
        previousStep: '上一步',
        complete: '完成',
        completeButton: '完成並分析',
        addMoreDetailsLater: '您稍後可以為個人資料新增更多詳細資訊'
      },
      snackbar: {
        closeButton: '關閉'
      },
      profileReminderSnackbar: {
        message: '完善您的個人資料，以獲得更精準的配對！',
        completeNow: '立即完善 →'
      },
      matchingProcess: {
        title: '配對中',
        whatIsNamecardDoing: 'Namecard.ai 正在做什麼？',
        analysisDescription: 'Namecard.ai 會分析您的數據，為您配對理想的合作夥伴，提供建立聯繫的理由和關鍵話題。'
      },
      validation: {
        personalEmailError: '請使用您的公司電子郵件地址，而非個人或臨時電子郵件。',
        invalidEmailError: '請確保您使用的是有效的電子郵件地址',
        invalidLinkedInUrlError: '請確保您使用有效的 LinkedIn 網址，且開頭為 https://www.linkedin.com/in/',
        invalidUrlError: '請確保您使用的是有效的 URL',
        pdfOnlyError: '請只上傳 PDF 檔案'
      },
      analyzing: '分析中',
      progressStatus: {
        analyzingRequest: '分析您的需求...',
        searchingExhibitors: '搜尋相關廠商...',
        smartMatching: '智慧配對中...',
        generatingResults: '生成結果...'
      },
      errors: {
        pdfUploadFailed: 'PDF 上傳失敗，請再試一次。',
        openaiUnavailable: 'OpenAI 服務目前無法使用，請稍後再試。',
        fetchMatchFailed: '出現問題了，讓我們重新試一次。',
        emptyQueryError: '無法讀取文件內容。請確認文件沒有設定密碼保護，或上傳包含更多文字內容的文件以便進行分析。',
        incompleteUrlError: '請填寫完整的 URL，並請重新搜尋'
      },
      namecardAi: 'Namecard.ai',
      trackUserGroups: {
        track5: 'BNI 台灣的新用戶',
        track6: 'BNI 美國的新用戶',
        track7: 'Computex 的新用戶',
        track0: 'Namecard 平台的新用戶'
      },
      detailDrawer: {
        matchReasonTitle: '配對理由'
      }
    },
    businessMatchContent: {
      title: '合作項目',
      matchingProcess: {
        title: '配對中',
        whatIsNamecardDoing: 'Namecard.ai 正在做什麼？',
        analysisDescription: 'Namecard.ai 會分析您的數據，為您配對理想的合作夥伴，提供建立聯繫的理由和關鍵話題。'
      },
      snackbar: {
        closeButton: '關閉'
      },
      errors: {
        openaiUnavailable: 'OpenAI 服務目前無法使用，請稍後再試。',
        fetchMatchFailed: '出現問題了，讓我們重新試一次。'
      },
      addButton: '新增合作項目',
      selectAllButton: '全選',
      deselectAllButton: '取消全選',
      startMatching: '開始媒合',
      notCategorized: '未分類',
      originalQueryPrefix: '原始查詢: ',
      demandLabel: '我想找',
      supplyLabel: '我提供',
      reasonPrefix: '原因: ',
      deleteDialog: {
        title: '確認刪除',
        message: '是否確定要刪除此選項？',
        cancelButton: '取消',
        confirmButton: '確認'
      },
      addDialog: {
        title: '新增合作項目',
        inputLabel: '請輸入關鍵字',
        cancelButton: '取消',
        addButton: '新增'
      },
      noOptionsTitle: '無法拆分合作項目',
      noOptionsMessage: '系統無法從您提供的資訊中識別出明確的合作項目。請返回上一頁重新輸入更具體的關鍵字或內容。',
      backToHomeButton: '返回重新輸入',
      invalidQueryDialog: {
        title: '無效的查詢',
        message: '您輸入的查詢無法產生新的合作項目。請嘗試輸入更具體或不同的關鍵字。',
        confirmButton: '確定'
      }
    },
    businessMatchHomePlaceholders: {
      workEmail: 'john@company.com',
      website: 'https://www.company.com',
      linkedin: 'https://www.linkedin.com/in/john',
      name: '輸入您的姓名',
      jobTitle: '請輸入職位',
      companyName: '輸入您的公司名稱',
      websiteShort: 'www.example.com',
      email: '請輸入電子郵件',
      phone: '請輸入電話',
      industry: '請選擇行業（最多5個）',
      searchIndustry: '搜尋行業...',
      bio: '簡單介紹您自己和您的專業背景...'
    },
    avatarMenu: {
      myProfile: '個人資料',
      matches: '我的媒合',
      supplyDemand: '合作項目',
      myContacts: '我的人脈',
      emailSent: '寄信紀錄',
      chatChannels: '聊天頻道',
      signOut: '登出',
      freePlan: {
        title: '免費方案',
        description: '獲得 30 天免費試用！輸入您的資料以解鎖付費功能。',
        startTrialButton: '開始免費試用'
      },
      freeTrial: {
        title: '免費試用',
        daysLeft: '剩餘 {days} 天',
        description: '再延長 30 天試用期！分享您的意見給我們。',
        giveFeedbackButton: '提供意見',
        upgradeButton: '立即升級'
      },
      premiumMember: {
        title: '付費會員',
        proBadge: 'Pro',
        description: '享受所有付費功能'
      },
      feedbackDialog: {
        title: '我們很重視您的意見',
        description: '請告訴我們如何改進我們的產品，讓您的使用體驗更加順暢。',
        feedbackLabel: '您的建議',
        feedbackRequired: '*',
        feedbackPlaceholder: '請輸入您的改進建議...',
        feedbackHelpText: '您的反饋將幫助我們改善產品功能。',
        cancelButton: '取消',
        submitButton: '提交建議'
      }
    },
    businessMatchResults: {
      matchScore: '適配度',
      explicitMatches: '僅顯示明確需求媒合',
      aiRecommendations: '僅顯示智能推薦',
      explicitMatchesLabel: '精準匹配',
      explicitMatchesTooltip: '顯示與您的需求或供給直接相符的結果',
      aiRecommendationsLabel: 'AI 智能推薦',
      aiRecommendationsTooltip: '透過 AI 分析，為您推薦潛在的合作夥伴',
      showAll: '顯示全部',
      filterTitle: '篩選',
      clearAllButton: '全部清除',
      locationFilterLabel: '國家',
      seeFewerOptions: '顯示較少選項',
      seeAllOptions: '顯示所有選項',
      industryFilterLabel: '產業',
      matchDirectionFilterLabel: '媒合方向',
      matchQueryFilterLabel: '媒合查詢',
      typeFilterLabel: '角色',
      regionFilterLabel: '地區',
      directionDemandToSupply: '需求媒合',
      directionSupplyToDemand: '供給媒合',
      directionBidirectional: '雙向媒合',
      noMoreResults: '沒有更多結果',
      applyFilterButton: '套用篩選',
      pageTitle: '您的專屬配對',
      pageTitleMobile: '您的專屬配對',
      pageSubtitle: '根據您的需求，我們產生了潛在商業夥伴的清單。您可以手動調整條件以即時調整結果。',
      shareButton: '分享',
      whatYourQuery: '您的媒合查詢:',
      whyMatchThis: '配對原因:',
      savedButton: '已儲存',
      saveContactButton: '儲存聯絡人',
      profileReminder: {
        title: '完成個人資料以獲得一個月免費付費會員',
        description: '填寫您的個人資料以解鎖更多功能',
        benefit1: '查看100筆搜尋結果',
        benefit2: '獲得更高的曝光機會',
        benefit3: '顯示推薦結果的聯絡資訊',
        laterButton: '稍後',
        goToProfileButton: '前往個人資料頁面'
      },
      unlockMoreResults: '解鎖更多結果',
      completeProfileToSeeMore: '填寫完整個人資料可以看更多結果',
      platformUser: '平台用戶',
      learnMoreButton: '查看詳情',
      noResultsFoundTitle: '找不到結果。',
      noResultsFoundSubtitle: '請使用不同的來源或關鍵字重試並再次配對。',
      retryButton: '重試',
      detailDrawer: {
        companyWebsiteTitle: '公司網站',
        descriptionTitle: '簡介',
        iHaveTitle: '提供項目',
        iWantTitle: '需求項目',
        matchSummaryTitle: '配對理由',
        contactTitle: '聯絡方式',
        savedToContactsButton: '已儲存至聯絡人',
        emailContactButton: '提出會議邀請',
        sendEmailButton: '發送信件',
        bniMemberDetailButton: 'BNI 會員詳細資料',
        connectButton: '聯繫',
        connectedButton: '已聯繫',
        alreadyContacted: '您已聯繫過此人',
        messageButton: '傳送訊息',
        emailSentAndAddedToNetwork: '信件已寄出並加入我的人脈',
        emailSendFailed: '信件寄送失敗',
        addedToContactList: '已加入對話名單，請至聊天頻道與對方對話',
        addedToContacts: '已加入聯絡人。點擊',
        chatChannel: '聊天頻道',
        toStartConversation: '開始對話。',
        contactSavedAndEmailSent: '成功加入我的人脈與寄出信件',
        contactSaved: '成功加入我的人脈',
        emailSent: '信件已成功寄出',
        connectSuccessConnected: '已成功連結。',
        connectSuccessStartConversation: '開始對話',
        connectSuccessAddedTo: '已加入',
        connectSuccessMyContacts: '我的人脈',
        connectSuccessNotifiedByEmail: ' — 已透過 email 通知對方',
        connectSuccessConnectedAddedTo: '已成功連結。已加入',
        connectFailed: '連結失敗，請稍後再試。',
        incompleteProfile: '請先完善您的個人資料再進行連結。',
        goToProfile: '前往個人資料'
      },
      sharingDialog: {
        title: '已建立公開連結',
        description: '已為您的配對建立公開連結。任何擁有此連結的人都可以查看這些配對。'
      },
      emailDialog: {
        sendEmailTo: '寄送 Email 給 {name}',
        subjectLabel: '主旨',
        messageLabel: '訊息',
        setUpAvailabilityButton: '設定可預約時間',
        cancelButton: '取消',
        sendEmailButton: '寄送 Email'
      },
      emailSuccessDialog: {
        title: 'Email 已成功寄出！',
        descriptionLine1: '您的介紹請求已寄給 {name}。',
        descriptionLine2: 'Namecard.ai 將協助協調雙方的會議時間。',
        viewSentEmailsButton: '查看已寄送的 Email',
        doneButton: '完成'
      },
      sendEmailDialog: {
        title: '發送信件給 {name}',
        subjectLabel: '主旨',
        subjectPlaceholder: '請輸入信件主旨',
        contentLabel: '信件內容',
        contentPlaceholder: '請輸入想對收信者說的話',
        systemNoteLabel: '系統會將以下文字帶入信件',
        sharingNote: '以下是我的名片分享連結，歡迎查閱並與我聯繫洽談商業合作機會：',
        cancelButton: '取消',
        sendButton: '發送'
      }
    },
    businessMatchSavedContacts: {
      matchScore: '適配度',
      platformUser: '平台用戶',
      whatYourQuery: '您的媒合查詢:',
      whyMatchThis: '配對原因:',
      viewMoreButton: '查看更多',
      learnMoreButton: '查看詳情',
      noSavedContactsTitle: '開始建立您的人脈網路',
      noSavedContactsSubtitle: '儲存感興趣的聯絡人，他們將會出現在這裡。',
      findContactsButton: '尋找聯絡人',
      noMoreResults: '沒有更多結果',
      detailDrawer: {
        descriptionTitle: '簡介',
        iHaveTitle: '提供項目',
        iWantTitle: '需求項目',
        matchSummaryTitle: '配對理由',
        contactTitle: '聯絡方式',
        companyWebsiteTitle: '公司網站',
        bniMemberDetailButton: 'BNI 會員詳細資料',
        removeFromContactsButton: '從我的聯絡人中移除',
        emailContactButton: '提出會議邀請',
        sendEmailButton: '發送信件',
        addedToContacts: '已加入聯絡人。點擊',
        chatChannel: '聊天頻道',
        toStartConversation: '開始對話。'
      },
      sendEmailDialog: {
        title: '發送信件給 {name}',
        subjectLabel: '主旨',
        subjectPlaceholder: '請輸入信件主旨',
        contentLabel: '信件內容',
        contentPlaceholder: '請輸入想對收信者說的話',
        systemNoteLabel: '系統會將以下文字帶入信件',
        sharingNote: '以下是我的名片分享連結，歡迎查閱並與我聯繫洽談商業合作機會：',
        cancelButton: '取消',
        sendButton: '發送'
      },
      emailDialog: {
        sendEmailTo: '寄送 Email 給 {name}',
        subjectLabel: '主旨',
        messageLabel: '訊息',
        setUpAvailabilityButton: '設定可預約時間',
        cancelButton: '取消',
        sendEmailButton: '寄送 Email'
      },
      emailSuccessDialog: {
        title: 'Email 已成功寄出！',
        descriptionLine1: '您的介紹請求已寄給 {name}。',
        descriptionLine2: 'Namecard.ai 將協助協調雙方的會議時間。',
        viewSentEmailsButton: '查看已寄送的 Email',
        doneButton: '完成'
      },
      deleteDialog: {
        confirmation: '您確定要將 {name} 從您的聯絡人中刪除嗎？',
        cancelButton: '取消',
        deleteButton: '刪除'
      }
    },
    businessMatchSharingMatchResults: {
      pageTitle: '探索您精心挑選的商業媒合。',
      pageSubtitle: '有人認為這些商業聯繫可能對您有價值。瀏覽精心策劃的潛在合作夥伴清單。',
      whatYourQuery: '您的媒合查詢:',
      whyMatchThis: '配對原因:',
      matchScore: '適配度',
      platformUser: '平台用戶',
      completeProfileToSeeMore: '填寫完整個人資料可以看更多結果',
      savedButton: '已儲存',
      saveContactButton: '儲存聯絡人',
      learnMoreButton: '了解更多',
      noResultsFoundTitle: '找不到結果。',
      noResultsFoundSubtitle: '請使用不同的來源或關鍵字重試並再次配對。',
      retryButton: '重試',
      detailDrawer: {
        descriptionTitle: '簡介',
        iHaveTitle: '提供項目',
        iWantTitle: '需求項目',
        matchSummaryTitle: '配對理由',
        contactTitle: '聯絡方式',
        savedToContactsButton: '已儲存至聯絡人',
        emailContactButton: '提出會議邀請',
        companyWebsiteTitle: '公司網站',
        bniMemberDetailButton: 'BNI 會員詳細資料',
        addedToContacts: '已加入聯絡人。點擊',
        chatChannel: '聊天頻道',
        toStartConversation: '開始對話。'
      },
      emailDialog: {
        sendEmailTo: '寄送 Email 給 {name}',
        subjectLabel: '主旨',
        messageLabel: '訊息',
        setUpAvailabilityButton: '設定可預約時間',
        cancelButton: '取消',
        sendEmailButton: '寄送 Email'
      },
      emailSuccessDialog: {
        title: 'Email 已成功寄出！',
        descriptionLine1: '您的介紹請求已寄給 {name}。',
        descriptionLine2: 'Namecard.ai 將協助協調雙方的會議時間。',
        viewSentEmailsButton: '查看已寄送的 Email',
        doneButton: '完成'
      },
      pageTitleMobile: '您的專屬配對',
      noMoreResults: '沒有更多結果'
    },
    nonLoginBusinessMatch: {
      findIdealMatches: '尋找理想的商務夥伴',
      matchWithMembers: '與能幫助您事業成長的 {title} 成員配對',
      matchWithMembersMobile: '與 {title} 成員配對，他們能幫助您的事業成長',
      titleAll: '所有',
      stepOf: '第 {current} 步，共 {total} 步',
      enterInfo: '輸入您的資訊',
      inputKeywords: '輸入關鍵字',
      uploadPdf: '上傳 PDF',
      workEmail: '公司 Email',
      websiteUrl: '公司網址',
      linkedinUrl: 'LinkedIn 網址',
      placeholderKeywords: '例如：我是裝潢公司，想找房仲合作...',
      keywordsDesc: '輸入關鍵字以尋找特定類型的會員或商機。',
      clickForExample: '點擊快速範例：',
      findMatches: '找到我的配對',
      switchToDemandKeywords: '切換到需求關鍵字搜尋',
      switchToSupplyKeywords: '切換到供應關鍵字搜尋',
      keywordsExample1: '找高雄的刑事訴訟律師',
      keywordsExample2: '找運動服加工廠，能處理吸濕排汗布料',
      keywordsExample3: '需要會計服務的公司',
      keywordsExampleForCompany1: '尋找標籤顯示器或電子紙',
      keywordsExampleForCompany2: '找客製化工業用電腦',
      keywordsExampleForCompany3: '虛擬實境應用廠商',
      supplyKeywordsExample1: '亞洲 TikTok 直播推廣',
      supplyKeywordsExample2: '協助品牌連結行銷高層',
      supplyKeywordsExample3: '日本跨境物流服務',
      supplyKeywordsExample1ForCes: '智慧型手機配件製造商尋找經銷商',
      supplyKeywordsExample2ForCes: '提供消費性電子 ODM 服務的設計公司',
      supplyKeywordsExample3ForCes: '智慧家庭整合商尋找硬體合作夥伴',
      examples: {
        other: {
          commonSearches: {
            title: '常見搜尋',
            examples: [
              '我提供房屋抵押貸款，想找房地產經紀人',
              '我提供清潔服務，想透過物業管理公司引薦客戶',
              '找需要會計服務的公司',
              '找醫療保險服務',
              '找 IT 顧問',
              '找西雅圖的室內裝修公司'
            ]
          },
          newCustomerDevelopment: {
            title: '開發新客戶',
            examples: [
              '找需要汽車貸款的客戶',
              '找需要攝影服務的客戶',
              '找需要農產原物料的客戶',
              '找需要金融服務的客戶',
              '尋找需要第三方支付或跨境金流解決方案的客戶'
            ]
          },
          professionalServices: {
            title: '專業服務',
            examples: [
              '找智慧財產權專業律師',
              '找社群行銷顧問',
              '找熟悉美國不動產交換稅法的專家',
              '需要法規遵循顧問，要熟悉台灣金融法規',
              '尋找一對一運動教練服務'
            ]
          },
          businessNetworking: {
            title: '業務人脈',
            examples: [
              '我是裝潢公司，想透過房仲引薦有裝潢需求的屋主',
              '我是保險業務，想透過車商引薦有車險需求的車主',
              '我提供包車服務，想透過旅行社找需要包車服務的客人',
              '我提供公證服務，想透過房貸專員引薦客戶'
            ]
          },
          regionalBusinessMatching: {
            title: '地區商機媒合',
            examples: [
              '找台北市的網站設計公司',
              '找新北市的室內設計師',
              '找高雄市的港口物流公司'
            ]
          }
        },
        track47: {
          productAndTechnology: {
            title: '產品及技術',
            examples: [
              '尋找NAS網路儲存設備，要支援RAID 10配置',
              '尋找 USB4 傳輸線，要支援 100W 快充',
              '尋找資料中心用的網路交換機',
              '尋找自動駕駛車輛用的 LiDAR 感測器',
              '尋找擁有 BCI(腦機介面) 及 EEG(腦電圖) 技術的供應商',
              '尋找協助行動不便與視障人士的智慧產品',
              '尋找國際設計獎得獎的消費電子產品',
              '尋找娛樂與媒體領域的新技術'
            ]
          },
          solutions: {
            title: '解決方案',
            examples: [
              '尋找智慧零售解決方案',
              '尋找邊緣運算解決方案，要支援 5G 模組',
              '尋找 ESG 碳排放管理解決方案',
              '尋找虛擬實境應用解決方案'
            ]
          },
          businessPartners: {
            title: '合作夥伴',
            examples: [
              '尋找 AI 新創加速器',
              '尋找電動車技術合作夥伴',
              '尋找全像投影相關供應鏈合作夥伴',
              '尋找金融科技公司合作開發解決方案',
              '尋找農業科技公司'
            ]
          },
          marketExpansion: {
            title: '市場拓展',
            examples: [
              '尋找電子消費產品經銷商',
              '尋找跨境電商平台',
              '尋找互動多媒體展演的通路推廣合作'
            ]
          },
          mediaMarketing: {
            title: '媒體行銷',
            examples: [
              '尋找報導產業新聞的媒體',
              '尋找科技Podcast合作',
              '尋找國際廣告代理商做整合行銷'
            ]
          }
        },
        track8: {
          franchiseExamples: {
            title: '加盟範例',
            examples: [
              '我們需要數位行銷與社群媒體管理服務',
              '我們需要員工培訓與認證系統',
              '我們需要選址評估與建置成本控制服務',
              '我們提供特許經營融資服務',
              '我們是行銷服務供應商，需要數據分析與行銷自動化技術'
            ]
          }
        }
      },
      uploadYourFile: '上傳您的檔案',
      dragPdfHere: '將 PDF 檔案拖放到這裡',
      releaseToUpload: '放開以上傳',
      orClickButton: '或點擊下方按鈕選擇檔案',
      selectFile: '選擇檔案',
      changeFile: '更換檔案',
      clickToChange: '點擊下方按鈕更換檔案',
      uploadPdfDescription: '上傳您的 PDF（例如 GAINs 表格）以尋找可以合作的會員。',
      workEmailDescription: '輸入您的公司 Email，尋找可能需要貴公司服務或產品的會員。',
      websiteUrlDescription: '輸入您的公司網址，尋找可能需要貴公司服務或產品的會員。',
      linkedInUrlDescription: '輸入您的 LinkedIn 網址，尋找可以建立人脈的會員。',
      membersDirectoryTitle: '會員名錄',
      trustedByTitle: '深受客戶信賴',
      snackbar: {
        closeButton: '關閉'
      },
      matchingProcess: {
        title: '配對中',
        whatIsNamecardDoing: 'Namecard.ai 正在做什麼？',
        analysisDescription: 'Namecard.ai 會分析您的數據，為您配對理想的合作夥伴，提供建立聯繫的理由和關鍵話題。'
      },
      validation: {
        personalEmailError: '請使用您的公司電子郵件地址，而非個人或臨時電子郵件。',
        invalidEmailError: '請確保您使用的是有效的電子郵件地址',
        invalidLinkedInUrlError: '請確保您使用有效的 LinkedIn 網址，且開頭為 https://www.linkedin.com/in/',
        invalidUrlError: '請確保您使用的是有效的 URL',
        pdfOnlyError: '請只上傳 PDF 檔案'
      },
      analyzing: '分析中',
      progressStatus: {
        analyzingRequest: '分析您的需求...',
        searchingExhibitors: '搜尋相關廠商...',
        smartMatching: '智慧配對中...',
        generatingResults: '生成結果...'
      },
      errors: {
        pdfUploadFailed: 'PDF 上傳失敗，請再試一次。',
        openaiUnavailable: 'OpenAI 服務目前無法使用，請稍後再試。',
        fetchMatchFailed: '擷取配對時發生錯誤，請再試一次。',
        emptyQueryError: '無法讀取文件內容。請確認文件沒有設定密碼保護，或上傳包含更多文字內容的文件以便進行分析。'
      },
      namecardAi: 'Namecard.ai'
    },
    nonLoginBusinessMatchPlaceholders: {
      workEmail: 'john@company.com',
      website: 'https://www.company.com',
      linkedin: 'https://www.linkedin.com/in/john'
    },
    timeCollection: {
      setTitle: '設定您的重複性可預約時間',
      timezoneQuestion: '您在哪個時區工作？',
      quickTemplatesTitle: '快速範本',
      showBusinessHoursButton: '顯示營業時間',
      showAllHoursButton: '顯示所有時間',
      setWeeklyAvailabilityTitle: '設定您的每週可預約時間',
      dragInstructionTooltip: '點擊並拖曳以一次選取或取消選取多個時段。',
      dragInstructionFooter: '點擊並拖曳以一次選取多個時段',
      meetingDurationQuestion: '會議時長應為多久？',
      repeatWeeksQuestion: '此設定應重複幾週？',
      repeatUntilDate: '您的可預約時間將重複至 {date}',
      saveButton: '建立時間投票會議',
      days: {
        monday: '週一',
        tuesday: '週二',
        wednesday: '週三',
        thursday: '週四',
        friday: '週五',
        saturday: '週六',
        sunday: '週日'
      },
      templates: {
        business: '營業時間 (上午9點-下午5點, 週一-週五)',
        extended: '延長時間 (上午8點-下午8點, 週一-週五)',
        weekends: '僅週末 (上午10點-下午4點, 週六-週日)',
        mornings: '僅上午 (上午8點-中午12點, 週一-週五)',
        afternoons: '僅下午 (下午1點-下午5點, 週一-週五)',
        evenings: '僅晚上 (下午6點-下午9點, 週一-週五)'
      },
      meetingDurations: {
        minutes: '{count} 分鐘'
      },
      repeatWeeks: {
        weeks: '{count} 週',
        month: '1 個月 (4 週)',
        months: '{monthCount} 個月 ({count} 週)' // 適用於 2 和 3 個月
      }
    },
    nonLoginBusinessMatchResults: {
      explicitMatches: '僅顯示明確需求媒合',
      aiRecommendations: '僅顯示智能推薦',
      explicitMatchesLabel: '精準匹配',
      explicitMatchesTooltip: '顯示與您的需求或供給直接相符的結果',
      aiRecommendationsLabel: 'AI 智能推薦',
      aiRecommendationsTooltip: '透過 AI 分析，為您推薦潛在的合作夥伴',
      showAll: '顯示全部',
      loginError: '請使用手機瀏覽器打開本頁面，以完成登入流程。',
      filterTitle: '篩選',
      clearAllButton: '全部清除',
      locationFilterLabel: '地點',
      seeFewerOptions: '顯示較少選項',
      seeAllOptions: '顯示所有選項',
      industryFilterLabel: '產業',
      matchDirectionFilterLabel: '媒合方向',
      matchQueryFilterLabel: '媒合查詢',
      typeFilterLabel: '角色',
      regionFilterLabel: '地區',
      applyFilterButton: '套用篩選',
      pageTitle: '您的專屬配對',
      pageSubtitle: '根據您的需求，我們產生了潛在商業夥伴的清單。您可以手動調整條件以即時調整結果。',
      shareButton: '分享',
      whatYourQuery: '您的媒合查詢:',
      whyMatchThis: '配對原因:',
      platformUser: '平台用戶',
      loginToSaveContactButton: '聯繫',
      loginToViewMore: '登入/註冊',
      learnMoreButton: '了解更多',
      noResultsFoundTitle: '找不到結果。',
      noResultsFoundSubtitle: '請使用不同的來源或關鍵字重試並再次配對。',
      retryButton: '重試',
      matchScore: '適配度',
      directionDemandToSupply: '需求媒合',
      directionSupplyToDemand: '供給媒合',
      directionBidirectional: '雙向媒合',
      noMoreResults: '沒有更多結果',
      detailDrawer: {
        descriptionTitle: '簡介',
        iHaveTitle: '提供項目',
        iWantTitle: '需求項目',
        matchSummaryTitle: '配對理由',
        companyWebsiteTitle: '公司網站',
        contactTitle: '聯絡方式',
        loginToSaveContactButton: '聯繫',
        loginToViewContactsButton: '查看聯絡方式',
        bniMemberDetailButton: 'BNI 會員詳細資料'
      },
      loginPromptDialog: {
        title: '登入以建立聯繫！',
        message: '登入/註冊即可儲存聯絡人、查看完整的聯絡方式，並享受更多專屬功能。',
        refineTitle: '解鎖更多精選配對',
        refineMessage: '登入/註冊即可解鎖更多精選配對、查看完整的聯絡方式，並享受更多專屬功能。',
        loginButton: '立即登入/註冊',
        cancelButton: '稍後再說'
      },
      sharingDialog: {
        title: '已建立公開連結',
        description: '已為您的配對建立公開連結。任何擁有此連結的人都可以查看這些配對。'
      },
      pageTitleMobile: '您的專屬配對'
    },
    nonLoginSharingMatchResults: {
      pageTitle: '有人為您分享了這些商業人脈。登入以獲取聯絡方式。',
      pageSubtitle: '有人認為這些商業聯繫可能對您有價值。瀏覽精心策劃的潛在合作夥伴清單。',
      whatYourQuery: '您的媒合查詢:',
      whyMatchThis: '配對原因:',
      savedButton: '已聯繫',
      saveContactButton: '聯繫',
      loginToSaveContactButton: '聯繫',
      learnMoreButton: '了解更多',
      noResultsFoundTitle: '找不到結果。',
      noResultsFoundSubtitle: '請使用不同的來源或關鍵字重試並再次配對。',
      retryButton: '重試',
      detailDrawer: {
        descriptionTitle: '簡介',
        iHaveTitle: '提供項目',
        iWantTitle: '需求項目',
        matchSummaryTitle: '配對理由',
        contactTitle: '聯絡方式',
        companyWebsiteTitle: '公司網站',
        savedToContactsButton: '已聯繫',
        loginToSaveContactButton: '聯繫',
      },
      loginToViewMore: '登入/註冊',
      loginError: '請使用手機瀏覽器打開本頁面，以完成登入流程。',
      matchScore: '適配度',
      platformUser: '平台用戶',
      pageTitleMobile: '您的專屬配對',
      whatCompanyOffersMobile: '此公司提供：',
      whatPersonOffersMobile: '此人提供：',
      noMoreResults: '沒有更多結果'
    },
    businessMatchProfile: {
      pageTitle: '編輯個人資料以獲得更好的配對結果',
      pageSubtitle: '您的個人資料是 Namecard.ai 配對建議的基礎，其他使用者無法公開查看。您可以直接編輯，或上傳新的來源供 AI 摘要。',
      editButton: '編輯',
      uploadSourceButton: '上傳來源',
      sourceLabel: '來源',
      viewAction: '檢視',
      deleteAction: '刪除',
      lastUpdatedLabel: '最後更新',
      getYourMatchesButton: '獲取您的配對',
      pageTitleMobile: '編輯個人資料以獲得更好的配對結果',
      pageSubtitleMobileTooltip: '您的個人資料是 Namecard.ai 配對建議的基礎，其他使用者無法公開查看。您可以直接編輯，或上傳新的來源供 AI 摘要。',
      historyButtonMobile: '歷史紀錄',
      editProfileButtonMobile: '編輯個人資料',
      feedbackHowsYourProfile: '您的個人資料如何？',
      feedbackLetUsKnow: '讓我們知道它是否符合您的期望。',
      likeButton: '讚',
      dislikeButton: '不讚',
      feedbackThanks: '感謝您的回饋！',
      discardChangesButton: '捨棄變更',
      saveButton: '儲存',
      uploadSourceDialog: {
        title: '上傳來源',
        subtitle: '上傳新的來源，Namecard.ai 將分析它們以重新產生您的個人化個人資料。',
        overwriteWarning: '請注意：上傳將覆蓋現有記錄。',
        addLinkedInTitle: '新增您的 LinkedIn 個人資料 URL',
        learnMoreLink: '了解更多',
        shareWebsiteTitle: '分享您的公司網站',
        urlInformationGuideLink: 'URL 資訊指南',
        uploadMaterialsTitle: '上傳公司資料',
        selectPdfButton: '選取 PDF 上傳',
        pdfSupportHint: '支援的檔案類型：PDF（最大 10MB）',
        closeButton: '關閉',
        insertButton: '插入'
      },
      deleteSourceDialog: {
        title: '您確定要刪除這些來源嗎？',
        subtitle: '刪除後，Namecard.ai 將根據可用資訊重新產生您的個人資料。',
        closeButton: '關閉',
        deleteButton: '刪除來源'
      },
      learnMoreDialog: {
        title: '如何分享您的 LinkedIn 個人資料',
        step1Text: '將您的 LinkedIn 個人資料設為公開，以便我們存取和分析您的資訊，以獲得更好的配對結果。',
        step1Link: '了解如何調整您的隱私設定',
        step2Text: '造訪您的 LinkedIn 個人資料頁面，複製您的個人資料 URL，然後將其貼到輸入欄位中。',
        backButton: '返回'
      },
      urlInfoDialog: {
        title: 'URL 資訊指南',
        point1: '輸入任何包含您業務內容的 URL',
        point2: '必須以 https:// 開頭',
        point3: 'URL 必須可公開存取',
        point4: '可包括公司網站、產品頁面、新聞稿等。',
        point5: '我們將分析內容以了解您的業務並建立更好的配對。',
        backButton: '返回'
      },
      snackbar: {
        closeButton: '關閉'
      },
      generatingProfileTitle: '正在產生個人資料',
      matchingTitle: '配對中',
      urlHint: '您可能需要在前面加上 "www"',
      validation: {
        invalidLinkedInUrlError: '請確保您使用的是有效的 LinkedIn 網址，且開頭為 https://www.linkedin.com/in/',
        invalidUrlError: '請確保您使用的是有效的 URL',
        invalidPdfError: '請確保您使用的是有效的 PDF'
      },
      errors: {
        pdfUploadFailed: 'PDF 上傳失敗，請再試一次。',
        maxSourcesExceeded: '您最多只能上傳 10 個來源。',
        sourceLoadFailed: '來源載入失敗。請重新提供 URL。',
        fetchMatchFailed: '擷取配對時發生錯誤，請再試一次。'
      },
      notifications: {
        profileUpdatedWithSource: '您的個人資料已使用您提供的新來源更新。',
        profileUpdated: '您的個人資料已更新',
        sourcesDeletedProfileUpdated: '來源已刪除，且您的個人資料已更新。',
        sourceDeleted: '您的來源已成功刪除。'
      }
    },
    userProfile: {
      myProfileTitle: '個人資料',
      analyzing: '正在分析您的個人資料',
      tabs: {
        basicInfo: '基本資訊',
        suppliesAndDemands: '供應與需求',
        profilePreview: '個人資料預覽'
      },
      basicInfoSection: {
        title: '基本資訊',
        profileStrength: '個人資料完整度：{value} %',
        fullNameLabel: '全名',
        fullNamePlaceholder: '您的全名',
        fullNameRequired: '請輸入您的全名',
        jobTitleLabel: '職稱',
        jobTitlePlaceholder: '您的職稱',
        emailLabel: 'Email',
        emailPlaceholder: '您的電子郵件地址',
        phoneLabel: '電話',
        phonePlaceholder: '您的聯絡電話',
        companyLabel: '公司',
        companyPlaceholder: '您公司的名稱',
        locationLabel: '地點',
        locationPlaceholder: '城市，國家',
        industryLabel: '產業（最多選擇 5 個）',
        industryPlaceholder: '選擇產業...',
        industriesSelected: '已選擇 {count} 個產業',
        industriesSelectedCount: '已選擇 {count}/5 個產業',
        companyWebsiteLabel: '公司網站',
        companyWebsitePlaceholder: 'www.example.com',
        linkedinUrlLabel: 'LinkedIn 網址',
        linkedinUrlPlaceholder: 'www.linkedin.com/in/yourprofile',
        pdfUploadLabel: '上傳 PDF',
        pdfUploadPlaceholder: '選擇 PDF 檔案',
        uploadButton: '上傳',
        changeButton: '更改',
        noIndustriesFound: '找不到相符的產業',
        bioLabel: '簡介',
        bioPlaceholder: '向他人介紹您自己和您的專業背景',
        saveButton: '儲存',
        analyzeButton: '開始分析',
        aiAnalyzeButton: '由AI分析'
      },
      suppliesDemandsSection: {
        title: '供應與需求',
        whatYouCanOfferTitle: '您能提供什麼',
        addNewButton: '新增',
        whatYouAreLookingForTitle: '您在尋找什麼',
        previousStepButton: '上一步',
        saveAndContinueButton: '儲存並繼續'
      },
      profilePreviewSection: {
        title: '個人資料預覽',
        shareProfileButton: '分享個人資料',
        whatIOfferTitle: '我提供',
        whatImLookingForTitle: '我正在尋找',
        noOfferingsAdded: '尚未新增任何項目',
        previousStepButton: '上一步',
        publishProfileButton: '發佈個人資料',
        publishSuccessfullyButton: '發佈成功',
        publicAndPreviewButton: '公開並預覽',
        publicLabel: '公開',
        privateLabel: '不公開'
      },
      editDemandDialog: {
        title: '編輯您正在尋找的項目'
      },
      editSupplyDialog: {
        title: '編輯您提供的項目'
      },
      addDemandDialog: {
        title: '新增您正在尋找的項目'
      },
      addSupplyDialog: {
        title: '新增您提供的項目'
      },
      editDialogCommon: {
        titleLabel: '標題（選填）',
        titlePlaceholder: '為此項目輸入標題',
        descriptionLabel: '描述',
        descriptionPlaceholder: '為此項目新增更多詳細資訊',
        cancelButton: '取消',
        saveChangesButton: '儲存變更'
      },
      addDialogCommon: {
        addItemButton: '新增項目'
      },
      // 新增的 UserProfile 翻譯
      visibility: {
        public: '公開',
        private: '不公開'
      },
      avatarUpload: {
        clickToChange: '點擊更換照片'
      },
      sections: {
        basicInfo: '個人基本資料',
        servicesAndDemands: '提供與需求',
        contactInfo: '聯繫方式',
        description: '描述'
      },
      services: {
        title: '我提供的',
        titleDialog: '我提供的服務',
        noServices: '尚未添加任何服務',
        addService: '新增服務',
        editService: '編輯服務'
      },
      demands: {
        title: '我尋找的',
        titleDialog: '我尋找的需求', 
        noDemands: '尚未添加任何需求',
        addDemand: '新增需求',
        editDemand: '編輯需求'
      },
      form: {
        nameLabel: '姓名',
        namePlaceholder: '請輸入您的姓名',
        nameRequired: '姓名為必填項目',
        jobTitleLabel: '職位',
        jobTitlePlaceholder: '請輸入您的職位',
        jobTitleRequired: '職位為必填項目',
        emailLabel: 'Email',
        emailPlaceholder: '請輸入您的 Email',
        emailRequired: 'Email為必填項目',
        phoneLabel: '電話',
        phonePlaceholder: '請輸入您的電話',
        companyNameLabel: '公司名稱',
        companyNamePlaceholder: '請輸入您的公司名稱',
        companyNameRequired: '公司名稱為必填項目',
        locationLabel: '地點',
        locationPlaceholder: '請輸入您的地點',
        companyUrlLabel: '公司網址',
        industryLabel: '行業',
        industryPlaceholder: '請選擇您的行業',
        industryRequired: '行業為必填項目',
        industryCount: '已選擇 {count} / 5 個行業',
        industryCountZero: '已選擇 0 / 5 個行業',
        bioLabel: '個人描述',
        bioPlaceholder: '請輸入您的個人描述',
        bioRequired: '個人描述為必填項目',
        pdfUploadLabel: '上傳 PDF',
        pdfPlaceholder: '選擇 PDF 文件',
        uploadText: '上傳',
        changeText: '更改'
      },
      dialogs: {
        editProfile: '編輯個人資料',
        editServicesAndDemands: '編輯服務與需求',
        editDemand: '編輯需求',
        editService: '編輯服務',
        addDemand: '新增需求',
        addService: '新增服務',
        aiAnalysis: '由 AI 分析',
        aiTooltip: 'AI 將根據您的公司名稱、公司網址及上傳的 PDF 文件來智慧分析並生成相關的服務需求與供應項目'
      },
      buttons: {
        cancel: '取消',
        save: '儲存',
        saveChanges: '儲存變更',
        addItem: '新增項目',
        edit: '編輯'
      },
      placeholders: {
        demandDescription: '請輸入需求描述',
        serviceDescription: '請輸入服務描述'
      },
      misc: {
        companyWebsite: '公司網址',
        mobileVersionDeveloping: '手機版正在開發中',
        descriptionLabel: '描述',
        pdfUploaded: 'PDF已上傳'
      }
    },
    mainLayout: {
      homeBreadcrumb: '首頁',
      sharingBreadcrumb: '分享',
      resultsBreadcrumb: '結果',
      contentBreadcrumb: '合作項目',
      myProfileBreadcrumb: '個人資料',
      myContactsBreadcrumb: '我的人脈',
      emailSentBreadcrumb: '寄信紀錄',
      loginButton: '登入/註冊',
      myProfile: '個人資料',
      // webviewLoginMessage: '為了安全考量，登入將在您的預設瀏覽器中開啟。繼續嗎？',
      loginError: '請使用手機瀏覽器打開本頁面，以完成登入流程。',
      nav: {
        matches: '配對',
        myProfile: '個人資料',
        feedback: '意見回饋',
        contactUs: '聯絡我們'
      },
      freeTrialBanner: {
        title: '您目前正在使用免費試用。',
        description: '升級以解鎖所有功能，並在試用期結束後繼續使用本平台。',
        upgradeButton: '立即升級'
      }
    },
    businessMatchEmailSent: {
      searchPlaceholder: '以主旨搜尋',
      to: '收件者',
      sendTime: '寄送時間'
    },
    nonLoginBusinessMatchContent: {
      title: '合作項目',
      matchingProcess: {
        title: '配對中',
        whatIsNamecardDoing: 'Namecard.ai 正在做什麼？',
        analysisDescription: 'Namecard.ai 會分析您的數據，為您配對理想的合作夥伴，提供建立聯繫的理由和關鍵話題。'
      },
      snackbar: {
        closeButton: '關閉'
      },
      errors: {
        openaiUnavailable: 'OpenAI 服務目前無法使用，請稍後再試。',
        fetchMatchFailed: '擷取配對時發生錯誤，請再試一次。'
      },
      addButton: '新增合作項目',
      selectAllButton: '全選',
      deselectAllButton: '取消全選',
      startMatching: '開始媒合',
      notCategorized: '未分類',
      originalQueryPrefix: '原始查詢: ',
      demandLabel: '我想找',
      supplyLabel: '我提供',
      reasonPrefix: '原因: ',
      deleteDialog: {
        title: '確認刪除',
        message: '是否確定要刪除此選項？',
        cancelButton: '取消',
        confirmButton: '確認'
      },
      addDialog: {
        title: '新增合作項目',
        inputLabel: '請輸入關鍵字',
        cancelButton: '取消',
        addButton: '新增'
      },
      noOptionsTitle: '無法拆分合作項目',
      noOptionsMessage: '系統無法從您提供的資訊中識別出明確的合作項目。請返回上一頁重新輸入更具體的關鍵字或內容。',
      backToHomeButton: '返回重新輸入',
      invalidQueryDialog: {
        title: '無效的查詢',
        message: '您輸入的查詢無法產生新的合作項目。請嘗試輸入更具體或不同的關鍵字。',
        confirmButton: '確定'
      }
    },
    common: {
      progressStatus: {
        analyzingRequest: '分析您的需求...',
        searchingMembers: '搜尋相關成員...',
        smartMatching: '智慧配對中...',
        generatingResults: '生成結果...'
      }
    },
    pricing: {
      pageTitle: '價格方案',
      pageSubtitle: '選擇最適合您的方案',
      currentPlanChip: {
        premiumUser: '您目前正使用付費方案',
        freeUser: '您目前正使用免費方案'
      },
      freePlan: {
        title: '免費方案',
        price: '$0',
        searchResults: '搜尋 3 筆結果'
      },
      premiumPlan: {
        title: '付費方案',
        price: '$99',
        perMonth: '/月',
        recommendedBadge: '推薦',
        searchResults: '搜尋 100 筆結果',
        showContactInfo: '顯示推薦結果聯繫方式',
        higherExposure: '獲得更高曝光機會',
        freeTrialPromotion: '填寫完整個人資料可獲得一個月付費資格',
        goToProfileButton: '前往個人資料頁面'
      }
    },
    sharingProfile: {
      profileTitle: '個人資料',
      addFriendButton: '加入好友',
      addFriendSuccess: '已成功加入好友',
      loginToAddFriendButton: '登入並與我聯繫'
    },
    chatRoom: {
      channels: '聊天頻道',
      members: '位成員',
      searchPlaceholder: '搜尋頻道...',
      inputPlaceholder: '輸入訊息...',
      selectChannelPrompt: '選擇一個頻道開始聊天',
      deleteConfirmTitle: '刪除對話',
      deleteConfirmMessage: '確定要刪除與 {name} 的對話嗎？',
      cancel: '取消',
      delete: '刪除',
      deleteConversation: '刪除對話',
      noMessages: '尚無訊息',
      today: '今天',
      yesterday: '昨天'
    },
    nonLoginChatRoom: {
      loginPromptTitle: '登入以開始對話',
      loginPromptMessage: '登入後即可發送訊息，與您的商業夥伴建立連結。',
      loginButton: '登入 / 註冊'
    }
  }